module.exports = __webpack_public_path__ + "img/u1206.71f083ff.svg";